import { authHeader, authHeaderFormData, handleResponse } from "../helpers";
export const loyalityschemeService = {
  createScheme,
  UpdateScheme,
  fetchSchemeData,
  inActiveRow,
  UploadSchemeMapping,
  fetchListDataDLL,
  GetZoneWisePointData,
  fetchContractorDLL,
  getDlrArctDistUsers,
  getArchitectsByContractor,
  getContractorsByPincode,
  getArchiCarpenterLoyaltyPoint,
};

function createScheme(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/CreateScheme`,
    requestOptions,
  ).then(handleResponse);
}

function UpdateScheme(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/UpdateScheme`,
    requestOptions,
  ).then(handleResponse);
}

// function fetchSchemeData(data) {
//   ;
//   const requestOptions = {
//     method: "POST",
//     headers: authHeader(),
//     body: JSON.stringify(data),
//   };

//   return fetch(
//     `${process.env.REACT_APP_API_URL}Loyalityscheme/GetSchemes`,
//     requestOptions
//   ).then(handleResponse);
// }

function fetchSchemeData(data) {
  // Force isActive to empty string
  const payload = {
    ...data,
    isActive: "",
  };

  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(payload),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/GetSchemes`,
    requestOptions,
  ).then(handleResponse);
}

function GetZoneWisePointData(StateId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  // Perform the fetch request
  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/GetPointsListOnStatewise/${StateId}`,
    requestOptions,
  ).then(handleResponse);
}

// function inActiveRow(SchemeId, isActive) {
//   const requestOptions = {
//     method: "GET",
//     headers: authHeader(),
//   };
//   return fetch(
//     `${process.env.REACT_APP_API_URL}Loyalityscheme/InActiveRow/${SchemeId}/${isActive}`,
//     requestOptions
//   ).then(handleResponse);
// }
function inActiveRow(SchemeId, isActive) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  // Convert numeric or string values to boolean
  const boolValue = isActive === true || isActive === 1 || isActive === "1";

  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/InActiveRowScheme/${SchemeId}/${boolValue}`,
    requestOptions,
  ).then(handleResponse);
}

function UploadSchemeMapping(formData) {
  const requestOptions = {
    method: "POST",
    headers: authHeaderFormData(),
    body: formData,
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/UploadSchemeMapping`,
    requestOptions,
  ).then(handleResponse);
}

function fetchListDataDLL() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/GetListDataDLL`,
    requestOptions,
  ).then(handleResponse);
}

function fetchContractorDLL() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/ContractorDDL`,
    requestOptions,
  ).then(handleResponse);
}

function getDlrArctDistUsers(RoleId) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/GetDlrArctectDistUsers?roleId=${RoleId}`,
    requestOptions,
  ).then(handleResponse);
}

function getArchitectsByContractor(ContractorId, RoleId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/GetArchitectsByContractor/${ContractorId}/${RoleId}`,
    requestOptions,
  ).then(handleResponse);
}

function getContractorsByPincode(Pincode) {
  const requestOptions = { method: "GET", headers: authHeader() };
  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/GetContractorsByPincode/${Pincode}`,
    requestOptions,
  ).then(handleResponse);
}

function getArchiCarpenterLoyaltyPoint(data) {
  const requestOptions = {
    method: "POST", // Changed to POST since you are sending a JSON payload body
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}Loyalityscheme/GetArchiCarpenterLoyaltyPoint`,
    requestOptions,
  ).then(handleResponse);
}
